import React from 'react';
import useExchangeTotalBalance from '../../hooks/use-exchange-total-balance.js';
import useFromAsset from '../../hooks/use-from-asset.js';
const AssetLabel = ({ Component, className, style }) => {
    const totalBalance = useExchangeTotalBalance();
    const [fromAsset] = useFromAsset();
    if (Component) {
        return (React.createElement(Component, { side: "from", asset: fromAsset, balance: totalBalance, className: className, style: style }));
    }
    return null;
};
export default AssetLabel;
